import ReactImgix, { Picture, Source } from "./react-imgix";
import { PublicConfigAPI } from "./config";

import { buildURLPublic as buildURL } from "./constructUrl";
export { buildURL };

export default ReactImgix;
export { Picture, Source, PublicConfigAPI };

export { Background } from "./react-imgix-bg";
